import { createAsyncAction } from 'typesafe-actions';

import generateLogger from '@travel/logger';
import { isNotEmptyArray } from '@travel/utils';

import { fetch } from './apis';
import { getDepartureAreas } from './selectors';
import { getSearchEngine } from 'store/searchEngine/selectors';

import type { AppThunk } from 'typesafe-actions';
import type {
  DeparturePlace,
  SearchAreasErrors,
  SearchAreasResponse,
  SearchAreaAccommodations,
} from 'SearchAreas-Types';
const logger = generateLogger();

export const fetchDepartureAreasAsync = createAsyncAction(
  'FETCH_DEPARTURE_AREAS_REQUEST',
  'FETCH_DEPARTURE_AREAS_SUCCESS',
  'FETCH_DEPARTURE_AREAS_FAILURE',
)<undefined, Array<DeparturePlace>, SearchAreasErrors>();

export const fetchSearchAreaResponseByDepartureAreaAsync = createAsyncAction(
  'FETCH_SEARCH_AREA_RESPONSE_BY_DEPARTURE_AREA_REQUEST',
  'FETCH_SEARCH_AREA_RESPONSE_BY_DEPARTURE_AREA_SUCCESS',
  'FETCH_SEARCH_AREA_RESPONSE_BY_DEPARTURE_AREA_FAILURE',
)<undefined, SearchAreasResponse, SearchAreasErrors>();

export const fetchSearchAreaResponseByAccommodationAreaAsync = createAsyncAction(
  'FETCH_SEARCH_AREA_RESPONSE_BY_ACCOMMODATION_AREA_REQUEST',
  'FETCH_SEARCH_AREA_RESPONSE_BY_ACCOMMODATION_AREA_SUCCESS',
  'FETCH_SEARCH_AREA_RESPONSE_BY_ACCOMMODATION_AREA_FAILURE',
)<undefined, SearchAreasResponse, SearchAreasErrors>();

export const fetchPlacesOfStayAsync = createAsyncAction(
  'FETCH_PLACES_OF_STAY_REQUEST',
  'FETCH_PLACES_OF_STAY_SUCCESS',
  'FETCH_PLACES_OF_STAY_FAILURE',
)<undefined, SearchAreaAccommodations, SearchAreasErrors>();

export const fetchDepartureAreas = (): AppThunk => async (dispatch, getState, { apiClient }) => {
  try {
    const existingDepartures = getDepartureAreas(getState());
    const searchEngine = getSearchEngine(getState())
    
    if (isNotEmptyArray(existingDepartures)) {
      dispatch(fetchDepartureAreasAsync.success(existingDepartures));
      return;
    }
    dispatch(fetchDepartureAreasAsync.request());

    const fetchedSearchAreaResponse = await fetch(apiClient, undefined, undefined, searchEngine);
    dispatch(fetchDepartureAreasAsync.success(fetchedSearchAreaResponse.departures));
  } catch (error) {
    logger.error(error);
    dispatch(fetchDepartureAreasAsync.failure(error as SearchAreasErrors));
  }
};

export const fetchSearchAreaResponseByDepartureArea = (departureArea: string): AppThunk => async (
  dispatch,
  _getState,
  { apiClient },
) => {
  try {
    const searchEngine = getSearchEngine(_getState())
    dispatch(fetchSearchAreaResponseByDepartureAreaAsync.request());
    const fetchedSearchAreaResponse = await fetch(apiClient, departureArea, undefined, searchEngine);
    dispatch(fetchSearchAreaResponseByDepartureAreaAsync.success(fetchedSearchAreaResponse));
  } catch (error) {
    logger.error(error);
    dispatch(fetchSearchAreaResponseByDepartureAreaAsync.failure(error as SearchAreasErrors));
  }
};

export const fetchPlacesOfStay = (
  departureArea: string,
  accommodationArea: string,
): AppThunk => async (dispatch, _getState, { apiClient }) => {
  try {
    const searchEngine = getSearchEngine(_getState())
    dispatch(fetchPlacesOfStayAsync.request());
    const fetchedSearchAreaResponse = await fetch(apiClient, departureArea, accommodationArea, searchEngine);
    dispatch(fetchPlacesOfStayAsync.success(fetchedSearchAreaResponse.accommodations));
  } catch (error) {
    logger.error(error);
    dispatch(fetchPlacesOfStayAsync.failure(error as SearchAreasErrors));
  }
};

export const fetchSearchAreaResponseByAccommodationArea = (
  accommodationArea: string,
): AppThunk => async (dispatch, _getState, { apiClient }) => {
  try {
    const searchEngine = getSearchEngine(_getState())
    dispatch(fetchSearchAreaResponseByAccommodationAreaAsync.request());

    const fetchedSearchAreaResponse = await fetch(apiClient, undefined, accommodationArea, searchEngine );
    dispatch(fetchSearchAreaResponseByAccommodationAreaAsync.success(fetchedSearchAreaResponse));
  } catch (error) {
    logger.error(error);
    dispatch(fetchSearchAreaResponseByAccommodationAreaAsync.failure(error as SearchAreasErrors));
  }
};
